import { render, staticRenderFns } from "./SlabItemSelector.vue?vue&type=template&id=b35ff960&scoped=true"
import script from "./SlabItemSelector.vue?vue&type=script&lang=js"
export * from "./SlabItemSelector.vue?vue&type=script&lang=js"
import style0 from "./SlabItemSelector.vue?vue&type=style&index=0&id=b35ff960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35ff960",
  null
  
)

export default component.exports